export default import.meta.ROLLUP_FILE_URL_8HSUfh7cJHNFxCkInNzNXw;